(() => {
  const handleFromHref = href => (href || "").match(/\/products\/([^\/\?#]+)/)?.[1] || null;
  
  const applyHandleAndVariant = () => {
    document.querySelectorAll('.card[data-fallback-link]').forEach(card => {
      const fallbackLink = card.getAttribute('data-fallback-link');
      if (!fallbackLink) return;
      
      const handle = handleFromHref(fallbackLink);
      if (!handle) return;
      
      card.setAttribute('data-product-handle', handle);
      
      const variantPicker = card.querySelector('[data-variant-picker]');
      if (variantPicker) {
        const selectedOption = variantPicker.querySelector('.variant-option.selected');
        if (selectedOption) {
          const variantId = selectedOption.getAttribute('data-variant-id');
          if (variantId) {
            card.setAttribute('data-variant-id', variantId);
          }
        }
        
        variantPicker.querySelectorAll('.variant-option').forEach(option => {
          const variantId = option.getAttribute('data-variant-id');
          if (variantId) {
            option.setAttribute('data-product-handle', handle);
            option.setAttribute('data-variant-id', variantId);
          }
        });
      }
      
      card.querySelectorAll('.button-text').forEach(btn => {
        btn.setAttribute('data-product-handle', handle);
        const selectedOption = card.querySelector('.variant-option.selected');
        if (selectedOption) {
          const variantId = selectedOption.getAttribute('data-variant-id');
          if (variantId) {
            btn.setAttribute('data-variant-id', variantId);
          }
        }
      });
    });
    
    if (window.Abra?.render) {
      window.Abra.render();
    }
  };
  
  applyHandleAndVariant();
  
  document.addEventListener('variantPickerSelected', (e) => {
    const { variantId, pickerId } = e.detail;
    
    const variantPicker = document.querySelector(`[data-variant-picker="${pickerId}"]`);
    if (!variantPicker) return;
    
    const card = variantPicker.closest('.card[data-fallback-link]');
    if (card && variantId) {
      card.setAttribute('data-variant-id', variantId);
      card.querySelectorAll('.button-text').forEach(btn => {
        btn.setAttribute('data-variant-id', variantId);
      });
      if (window.Abra?.render) {
        window.Abra.render();
      }
    }
  });
})();

(() => {
  const addSubscriptionAnchors = () => {
    document.querySelectorAll('.shopify_subscriptions_app_block_label.shopify_subscriptions_purchase_option_wrapper').forEach(wrapper => {
      if (!wrapper.classList.contains('one-time-wrapper')) {
        wrapper.classList.add('one-time-wrapper');
      }
      const input = wrapper.querySelector('input[data-radio-type="one_time_purchase"]');
      if (input) {
        const variantId = input.getAttribute('data-variant-id');
        if (variantId) {
          wrapper.setAttribute('data-variant-id', variantId);
        }
      }
    });

    document.querySelectorAll('.shopify_subscriptions_app_block_label:not(.shopify_subscriptions_purchase_option_wrapper)').forEach(wrapper => {
      if (!wrapper.classList.contains('subscribe-wrapper')) {
        wrapper.classList.add('subscribe-wrapper');
      }
      const input = wrapper.querySelector('input[data-radio-type="selling_plan"]');
      if (input) {
        const variantId = input.getAttribute('data-variant-id');
        if (variantId) {
          wrapper.setAttribute('data-variant-id', variantId);
        }
      }
    });
  };

  addSubscriptionAnchors();

  const observer = new MutationObserver(addSubscriptionAnchors);
  const subscriptionBlock = document.querySelector('.shopify_subscriptions_app_block');
  if (subscriptionBlock) {
    observer.observe(subscriptionBlock, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', addSubscriptionAnchors);
  setTimeout(addSubscriptionAnchors, 100);
  setTimeout(addSubscriptionAnchors, 300);
  setTimeout(addSubscriptionAnchors, 600);
})();